import React from 'react';
import { CheckCircle2 } from 'lucide-react';
interface BonusCardProps {
  title: string;
  description: string;
  value: string;
  image: string;
}
export const BonusCard: React.FC<BonusCardProps> = ({
  title,
  description,
  value,
  image
}) => {
  return <div className="bg-white p-5 sm:p-6 rounded-3xl shadow-[0_8px_30px_rgba(0,0,0,0.04)] border border-gray-100 flex flex-col sm:flex-row gap-5 sm:gap-6 items-center sm:items-start transition-transform duration-300 hover:-translate-y-1" data-id="element-8">
      <div className="w-32 h-44 sm:w-28 sm:h-40 flex-shrink-0 rounded-xl overflow-hidden shadow-md border border-gray-50" data-id="element-9">
        <img src={image} alt={title} className="w-full h-full object-cover" data-id="element-10" />
      </div>
      <div className="flex-1 text-center sm:text-left flex flex-col justify-center h-full pt-2 sm:pt-0" data-id="element-11">
        <div className="flex items-start justify-center sm:justify-start gap-2 mb-2" data-id="element-12">
          <CheckCircle2 className="w-6 h-6 text-[#008080] flex-shrink-0 mt-0.5 hidden sm:block" data-id="element-13" />
          <h4 className="font-bold text-lg md:text-xl text-gray-900 leading-tight" data-id="element-14">
            {title}
          </h4>
        </div>
        <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-4" data-id="element-15">
          {description}
        </p>
        <div className="mt-auto" data-id="element-16">
          <span className="text-xs md:text-sm font-bold text-[#FF8C00] bg-orange-50 inline-block px-3 py-1.5 rounded-full uppercase tracking-wide" data-id="element-17">
            {value}
          </span>
        </div>
      </div>
    </div>;
};